import { CommonModule } from '@angular/common';
/* eslint-disable prefer-const */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { of, tap } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LMSPageTitleService } from 'src/app/core/services/lmspage-headertitle.service';
import { MdbModalModule, MdbModalRef, MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';

import { LMSConstantsService } from '@lmsConstants';
import { ClientDetailsService, QuoteStoreService } from '@lmsrestServices';
import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

import { LMS_NoSpecialsDirective } from '../../directives';

@Component({
  selector: 'app-agent-compliance-notification-dialog',
  templateUrl: './agent-compliance-notification-dialog.component.html',
  styleUrls: ['./agent-compliance-notification-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MdbModalModule, MdbSelectModule, LMS_NoSpecialsDirective, LmsModalFrameComponent],
})
export class AgentComplianceNotificationDialogComponent implements OnInit {
  agentComplianceNotificationForm = this.fb.group({
      occupation: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      maritalStatus: ['', [Validators.required]],
      nationality: ['', []],
      homeLine1: ['', [Validators.required]],
      homeLine2: [''],
      homeSuburb: ['', [Validators.required]],
      homeTown: ['', [Validators.required]],
      homeAreaCode: ['', [Validators.minLength(4)]],
      homeProvince: ['', [Validators.required]],
    });

  lstNationality: any[];
   lstProvinces = this.lmsConstantService.getLMSConstant('COMPLIANCEPROVINCES');
    lstGenders = this.lmsConstantService.getLMSConstant('GENDERS');
    lstCompMAritalStatus = this.lmsConstantService.getLMSConstant('COMPLIANCEMARITALSTATUS');

  clientDetails: any;
  submitted = false;
  countryWght: number;

  constructor(
    public fb: FormBuilder,
    public quoteStoreService: QuoteStoreService,
    public clientSearch: ClientDetailsService,
    public dialogRef: MdbModalRef<AgentComplianceNotificationDialogComponent>,
    private lmsPageTitleService: LMSPageTitleService,
    public global_utility: AppUtilityService,
    private lmsConstantService: LMSConstantsService
  ) {
    this.lmsPageTitleService.setPageTitle('Compliance Notification');
  }

  ngOnInit(): void {
    if(this.clientSearch.clientResult) {
      const clientdata$ = of(this.clientSearch.clientResult);

      clientdata$.pipe(
        tap((data) => {
          this.fetchComplianceData(data);
        })
      ).subscribe();
    }
  }

  get occupation() {
    return this.agentComplianceNotificationForm.get('occupation');
  }

  get gender() {
    return this.agentComplianceNotificationForm.get('gender');
  }

  get maritalStatus() {
    return this.agentComplianceNotificationForm.get('maritalStatus');
  }

  get homeLine1() {
    return this.agentComplianceNotificationForm.get('homeLine2');
  }
  get homeLine2() {
    return this.agentComplianceNotificationForm.get('homeLine2');
  }
  get homeSuburb() {
    return this.agentComplianceNotificationForm.get('homeSuburb');
  }
  get homeTown() {
    return this.agentComplianceNotificationForm.get('homeTown');
  }
  get homeAreaCode() {
    return this.agentComplianceNotificationForm.get('homeAreaCode');
  }
  get homeProvince() {
    return this.agentComplianceNotificationForm.get('homeProvince');
  }

  fetchComplianceData(data: any) {
    let preAuthorisationModel = {...data};

    preAuthorisationModel.fullNames = data.firstName;
    preAuthorisationModel.surname = data.lastName;
    preAuthorisationModel.userName = data.createdBy;
    preAuthorisationModel.quoteId = data.id;

    this.clientSearch.findExistingComplianceData(data).subscribe({
      next: (result: any) => {
        if(!result) {
          this.agentComplianceNotificationForm.reset();
        }

        this.agentComplianceNotificationForm.patchValue(result);
      },
      error:(err) =>{
        this.global_utility.error(err, 'Compliance data Error');
      }
    });
  }

  submit() {
    this.submitted = true;
    if (this.agentComplianceNotificationForm.valid) {
      this.dialogRef.close(this.agentComplianceNotificationForm.value);
    }
  }
}
